<dx-popup [width]="1320" [height]="640" title="Apply After State" [showTitle]="true"
   [closeOnOutsideClick]="false" [resizeEnabled]="true" [dragEnabled]="true"
   [visible]="isVisible" (onHidden)="onHidden()">
   <div *dxTemplate="let data of 'content'" class="container">

      <!-- Same header block as the preview pop-up (visual parity). No hint line — owner removed it
           (vrequest 2026-06-10 #3): the "After State" header is enough. -->
      <div class="header">
         <div class="title">
            After State
         </div>
      </div>

      <hr style="border-color: #3a3e44; width: 80%">

      <!-- Cloned hg-after-state Before / Transaction / After look (the SAME markup shape as the preview
           pop-up). PRICE-FREE display; the only editable control is the per-transaction-leg ACTUAL-FILL box
           on the aligned Transaction leg. -->
      <div class="content">
         <dx-scroll-view>
            <div class="state">

               <ng-container *ngFor="let block of blocks">
                  <!-- Combo separator only when the scope spans more than one combo (portfolio scope). -->
                  <div class="combo-sep" *ngIf="multiCombo">{{ block.comboName }}</div>

                  <div class="row" *ngFor="let grp of block.groups" [class.excluded]="!grp.enabled">
                     <!-- Group title bar (HG after-state parity): [ON/OFF switch] [name] [discard X].
                          OFF = session-only exclude (dimmed, not booked, key kept). X = permanent discard
                          of this bucket's saved plan (confirmed). A BLOCKED section (invalid saved plan)
                          drops the switch — the X is its only action. Both controls go inert mid-apply. -->
                     <div class="row-title" [style.color]="grp.display.color">
                        <dx-switch *ngIf="!grp.blocked" class="grp-switch"
                           [value]="grp.enabled"
                           [disabled]="busy"
                           (valueChange)="onToggleGroup(grp, $event)"></dx-switch>
                        <div class="hedge-name">{{ grp.display.label }}</div>
                        <i class="fa fa-times-circle grp-discard" [class.inert]="busy"
                           title="Discard this bucket's saved After State"
                           (click)="onDiscardGroup(grp)"></i>
                     </div>

                     <!-- Invalid saved plan: reason + discard X only; nothing bookable, and it never gates
                          the OTHER groups' Apply. -->
                     <div class="blocked" *ngIf="grp.blocked">
                        {{ grp.blockReason }}<ng-container *ngIf="!grp.locked"> — discard this bucket's saved plan (X above) or fix it via
                        Make Transaction.</ng-container>
                     </div>

                     <!-- OPTION groups: the full Qty/Side/Type/Expiration/Strike clone. -->
                     <div class="row-data" *ngIf="!grp.blocked && !grp.display.isAsset">

                        <!-- Before = current live legs (face value). -->
                        <div class="col before">
                           <table>
                              <tr class="group-name" [style.color]="grp.display.color">
                                 <td colspan="5">Before</td>
                              </tr>
                              <tr class="headers" [style.color]="grp.display.color">
                                 <td>Qty</td>
                                 <td>Side</td>
                                 <td>Type</td>
                                 <td>Expiration</td>
                                 <td>Strike</td>
                              </tr>
                              <tr *ngFor="let leg of grp.display.before" class="row" [style.color]="grp.display.color">
                                 <td>{{ leg.qty }}</td>
                                 <td>{{ (leg.side * leg.qty) | etsQtyToMarketSide }}</td>
                                 <!-- A mixed group renders in this option table; its asset legs have no
                                      Type — show the ticker there so the leg is never anonymous. -->
                                 <td>{{ leg.kind === 0 ? leg.ticker : leg.type }}</td>
                                 <td>{{ leg.expiration | etsFriendlyDatePipe:'full':qgCursorDayOf(leg) }}</td>
                                 <td>{{ leg.strike }}</td>
                              </tr>
                              <tr class="footer">
                                 <td colspan="5">&nbsp;</td>
                              </tr>
                           </table>
                        </div>

                        <!-- Transaction = derived deltas. Each leg carries its operator ACTUAL-FILL box,
                             index-aligned to grp.fills (same diff deltas, same order). -->
                        <div class="col transaction">
                           <table>
                              <tr class="group-name" [style.color]="grp.display.color">
                                 <td colspan="6">Transaction</td>
                              </tr>
                              <tr class="headers" [style.color]="grp.display.color">
                                 <td>Action</td>
                                 <td>Qty</td>
                                 <td>Type</td>
                                 <td>Expiration</td>
                                 <td>Strike</td>
                                 <td>Fill Px</td>
                              </tr>
                              <tr *ngFor="let leg of grp.display.transaction; let i = index" class="row" [style.color]="grp.display.color">
                                 <td>{{ leg.operation }}</td>
                                 <!-- SIGNED trade qty (owner 2026-06-11): the sign IS the side — buy positive,
                                      sell negative. Before/After keep positive qty + a Long/Short label; a
                                      transaction is a trade, so direction rides the number. -->
                                 <td>{{ leg.side * leg.qty }}</td>
                                 <!-- Asset delta in a mixed group: no Type — show the ticker there (same
                                      convention as Before/After), so the operator never prices an unnamed
                                      instrument. Its Expiration cell stays blank. -->
                                 <td>{{ leg.kind === 0 ? leg.ticker : leg.type }}</td>
                                 <td>{{ leg.kind === 0 ? '' : (leg.expiration | etsFriendlyDatePipe:'full':qgCursorDayOf(leg)) }}</td>
                                 <td>{{ leg.strike }}</td>
                                 <td class="fill-cell">
                                    <!-- $-masked, compact (<= 3 digits before the decimal + 2 after).
                                         Committed per keystroke (valueChangeEvent="input") through the
                                         decorated handler — the DX default 'change' commit left the Apply
                                         gate stale until blur. -->
                                    <dx-number-box [min]="0" format="$#,##0.00"
                                       valueChangeEvent="input"
                                       [disabled]="!grp.enabled"
                                       [inputAttr]="dxCenterTextStyleObj"
                                       [value]="grp.fills[i].actualAvgPx"
                                       (valueChange)="onFillPxChange(grp, i, $event)"></dx-number-box>
                                 </td>
                              </tr>
                              <tr class="footer">
                                 <td colspan="6">&nbsp;</td>
                              </tr>
                           </table>
                        </div>

                        <!-- After = the saved end-state. -->
                        <div class="col after">
                           <table>
                              <tr class="group-name" [style.color]="grp.display.color">
                                 <td colspan="5">After</td>
                              </tr>
                              <tr class="headers" [style.color]="grp.display.color">
                                 <td>Qty</td>
                                 <td>Side</td>
                                 <td>Type</td>
                                 <td>Expiration</td>
                                 <td>Strike</td>
                              </tr>
                              <tr *ngFor="let leg of grp.display.after" class="row" [style.color]="grp.display.color">
                                 <td>{{ leg.qty }}</td>
                                 <td>{{ (leg.side * leg.qty) | etsQtyToMarketSide }}</td>
                                 <!-- A mixed group renders in this option table; its asset legs have no
                                      Type — show the ticker there so the leg is never anonymous. -->
                                 <td>{{ leg.kind === 0 ? leg.ticker : leg.type }}</td>
                                 <td>{{ leg.expiration | etsFriendlyDatePipe:'full':qgCursorDayOf(leg) }}</td>
                                 <td>{{ leg.strike }}</td>
                              </tr>
                              <tr class="footer">
                                 <td colspan="5">&nbsp;</td>
                              </tr>
                           </table>
                        </div>
                     </div>

                     <!-- ASSET (underlying) groups: no strikes/expirations -> the simpler Ticker/Qty/Side table. -->
                     <div class="row-data" *ngIf="!grp.blocked && grp.display.isAsset">
                        <div class="col before">
                           <table>
                              <tr class="group-name" [style.color]="grp.display.color">
                                 <td colspan="3">Before</td>
                              </tr>
                              <tr class="headers" [style.color]="grp.display.color">
                                 <td>Ticker</td>
                                 <td>Qty</td>
                                 <td>Side</td>
                              </tr>
                              <tr *ngFor="let leg of grp.display.before" class="row" [style.color]="grp.display.color">
                                 <td>{{ leg.ticker }}</td>
                                 <td>{{ leg.qty }}</td>
                                 <td>{{ (leg.side * leg.qty) | etsQtyToMarketSide }}</td>
                              </tr>
                              <tr class="footer">
                                 <td colspan="3">&nbsp;</td>
                              </tr>
                           </table>
                        </div>
                        <div class="col transaction">
                           <table>
                              <tr class="group-name" [style.color]="grp.display.color">
                                 <td colspan="4">Transaction</td>
                              </tr>
                              <tr class="headers" [style.color]="grp.display.color">
                                 <td>Action</td>
                                 <td>Ticker</td>
                                 <td>Qty</td>
                                 <td>Fill Px</td>
                              </tr>
                              <tr *ngFor="let leg of grp.display.transaction; let i = index" class="row" [style.color]="grp.display.color">
                                 <td>{{ leg.operation }}</td>
                                 <td>{{ leg.ticker }}</td>
                                 <!-- SIGNED trade qty — buy positive, sell negative (same rule as the option table). -->
                                 <td>{{ leg.side * leg.qty }}</td>
                                 <td class="fill-cell">
                                    <!-- $-masked, compact (<= 3 digits before the decimal + 2 after).
                                         Per-keystroke commit — same fix as the option table's fill box. -->
                                    <dx-number-box [min]="0" format="$#,##0.00"
                                       valueChangeEvent="input"
                                       [disabled]="!grp.enabled"
                                       [inputAttr]="dxCenterTextStyleObj"
                                       [value]="grp.fills[i].actualAvgPx"
                                       (valueChange)="onFillPxChange(grp, i, $event)"></dx-number-box>
                                 </td>
                              </tr>
                              <tr class="footer">
                                 <td colspan="4">&nbsp;</td>
                              </tr>
                           </table>
                        </div>
                        <div class="col after">
                           <table>
                              <tr class="group-name" [style.color]="grp.display.color">
                                 <td colspan="3">After</td>
                              </tr>
                              <tr class="headers" [style.color]="grp.display.color">
                                 <td>Ticker</td>
                                 <td>Qty</td>
                                 <td>Side</td>
                              </tr>
                              <tr *ngFor="let leg of grp.display.after" class="row" [style.color]="grp.display.color">
                                 <td>{{ leg.ticker }}</td>
                                 <td>{{ leg.qty }}</td>
                                 <td>{{ (leg.side * leg.qty) | etsQtyToMarketSide }}</td>
                              </tr>
                              <tr class="footer">
                                 <td colspan="3">&nbsp;</td>
                              </tr>
                           </table>
                        </div>
                     </div>
                  </div>
               </ng-container>

               <div class="empty" *ngIf="!busy && !hasFills">
                  Nothing to apply — no saved end-state under this scope.
               </div>
               <div class="empty" *ngIf="busy">
                  Loading the saved plan…
               </div>
            </div>
         </dx-scroll-view>
      </div>

      <hr style="border-color: #3a3e44; width: 80%">

      <div class="footer">
         <div class="btn cancel">
            <dx-button text="Cancel" [disabled]="busy" (onClick)="onCancel()" width="100%"></dx-button>
         </div>
         <div class="btn apply">
            <dx-button text="Apply" type="danger" [disabled]="!canApply()" (onClick)="onApply()" width="100%"></dx-button>
         </div>
      </div>
   </div>
</dx-popup>

<!-- Shared ETS confirmation (resolve = Yes, reject = No) for the per-bucket discard X. -->
<ets-generic-confirmation-dialog #applyConfirm [title]="confirmTitle"></ets-generic-confirmation-dialog>
